











































































































































































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import quotationServices from '@/services/quotation-services';

const numeral = require('numeral');

@Component({
    components: {
        Loading,
        Paging,
    }
})
export default class ListQuotationComplaints extends Vue {
    private isLoading: boolean = false;
    private items: any[] = [];
    private currentStatus: string = 'all';
    private searchTerm: string = '';
    private currentPage: number = 1;
    private rowsPerPage: number = 15;
    private totalRows: number = 0;
    private totalPages: number = 1;

    private statusTabs = [
        { value: 'all', name: 'Tất cả', color: '#fff' },
        { value: '1', name: 'Chờ tiếp nhận', color: '#f0ad4e' },
        { value: '2', name: 'Đang xử lý', color: '#337ab7' },
        { value: '3', name: 'Đã bồi thường', color: '#00b300' },
        { value: '4', name: 'Từ chối', color: '#d9534f' },
        { value: '0', name: 'Đã hủy', color: '#999999' },
    ];

    private stats = {
        all: 0,
        pending: 0,
        processing: 0,
        compensated: 0,
        rejected: 0,
        cancelled: 0,
    };

    get selectedStatusObj() {
        return this.statusTabs.find(s => s.value === this.currentStatus) || this.statusTabs[0];
    }

    private async created() {
        await Promise.all([
            this.loadStats(),
            this.loadData()
        ]);
    }

    private async loadStats() {
        try {
            const res: any = await quotationServices.getComplaintStatusCounts();
            if (res && res.data && res.data.status === 200 && res.data.data) {
                this.stats = Object.assign(this.stats, res.data.data);
            }
        } catch (e) {
            console.error('Failed to load complaint status counts', e);
        }
    }

    private async loadData() {
        this.isLoading = true;
        try {
            const res: any = await quotationServices.getComplaintsList(
                this.currentPage,
                this.rowsPerPage,
                this.currentStatus,
                this.searchTerm
            );
            if (res && res.data && res.data.status === 200) {
                this.items = res.data.data || [];
                this.totalRows = res.data.total || 0;
                this.totalPages = res.data.num_pages || Math.ceil(this.totalRows / this.rowsPerPage) || 1;
            } else {
                this.items = [];
                this.totalRows = 0;
                this.totalPages = 1;
            }
        } catch (err) {
            console.error('Failed to fetch quotation complaints:', err);
            this.items = [];
            this.totalRows = 0;
            this.totalPages = 1;
        } finally {
            this.isLoading = false;
        }
    }

    private changeStatus(status: string) {
        this.currentStatus = status;
        this.currentPage = 1;
        this.loadData();
    }

    private onSearch() {
        this.currentPage = 1;
        this.loadData();
    }

    private changePage(page: number) {
        this.currentPage = page;
        this.loadData();
    }

    private viewDetail(item: any) {
        const routeData = this.$router.resolve({
            name: 'detail-quotation-complain',
            params: {
                orderId: item.OrderID ? item.OrderID.toString() : '0',
                complainId: item.ID ? item.ID.toString() : '0',
                orderType: '5'
            }
        });
        window.open(routeData.href, '_blank');
    }

    private getCount(statusValue: string) {
        switch (statusValue) {
            case 'all': return this.stats.all || 0;
            case '1': return this.stats.pending || 0;
            case '2': return this.stats.processing || 0;
            case '3': return this.stats.compensated || 0;
            case '4': return this.stats.rejected || 0;
            case '0': return this.stats.cancelled || 0;
            default: return 0;
        }
    }

    private formatCurrency(val: any) {
        const n = Number(val) || 0;
        return numeral(n).format('0,0');
    }

    private formatNumber(val: any) {
        const n = Number(val) || 0;
        return numeral(n).format('0,0.[00]');
    }

    private getStatusColor(st: number): string {
        switch (st) {
            case 1: return '#f0ad4e';
            case 2: return '#337ab7';
            case 3: return '#00b300';
            case 4: return '#d9534f';
            case 0: return '#999999';
            default: return '#3b4354';
        }
    }

    private getStatusName(st: number) {
        switch (st) {
            case 1: return 'Chờ tiếp nhận';
            case 2: return 'Đang xử lý';
            case 3: return 'Đã bồi thường';
            case 4: return 'Từ chối';
            case 0: return 'Đã hủy';
            default: return 'Khác';
        }
    }

    private getResMethodName(m: number) {
        switch (m) {
            case 1: return 'Bồi thường tiền';
            case 2: return 'Đổi trả hàng';
            case 3: return 'Phát bù hàng';
            case 4: return 'Khác';
            default: return 'Bồi thường tiền';
        }
    }
}
